module.exports = __webpack_public_path__ + "img/image1.e0af1a0a.jpg";